import React, { useContext, useEffect, useState } from 'react';
import StyledButton from '~/components/StyledButton';
import { TopicCard } from '~/types';
import { generateTopicSlug } from '~/util/util';
import { AppContext } from '~/contexts/AppContext';
import axios, { AxiosResponse } from 'axios';
import TopicCardComponent from '~/components/TopicCard';

import Fade from '~/components/Fade';
import { animated, useSpring } from 'react-spring';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare';
import StyledContentPanel from '~/components/StyledContentPanel';

interface RatingEndProps {
    resetRating: () => void;
    selectNextTopic: (topicSlug: string) => void;
}

const RatingEnd: React.FC<RatingEndProps> = ({ resetRating, selectNextTopic }) => {

    const { apiUrl, topicData } = useContext(AppContext)!;
    const { topicHash }: { topicHash: string } = useParams();

    const [topics, setTopics] = useState<TopicCard[] | null>(null);

    const { t } = useTranslation();

    const [ratingEndContainerStyle, ratingEndContainerApi] = useSpring(() => ({
        opacity: 1
    }));

    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!topicData)
            return;

        //setGlassPanelBackdropFilter(0, 1, 1);

        axios.get(`${apiUrl}/topic/${generateTopicSlug(topicData.topic.name)}/next`).then((res: AxiosResponse) => {
            setTopics(res.data.nextTopics);
        });
    }, []);

    const topicCardClicked = (topic: TopicCard) => {
        ratingEndContainerApi.start({
            opacity: 0,
            config: { duration: 200 },
            onRest: () => {
                if (topic) {
                    selectNextTopic(topic.slug);
                    //resetVote();
                    //history.push(generateTopicSlug(topic.name));
                }
            }
        });
    };

    const copyTopicLink = () => {

        if (!topicData) return;

        const el = document.createElement('textarea');
        el.value = `https://m.kazva.bg/m/${topicHash}.html?s=share`
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);

    };

    const shareTopic = () => {
        const shareData = {
            // title: "Kazva BG",
            // text: "Виж какво казват другите спрямо твоето мнение с kazva bg.",
            url: `https://m.kazva.bg/m/${topicHash}.html?s=share`,
        };
        navigator.share(shareData);
    };

    return (
        <animated.div style={ratingEndContainerStyle}>
            <Fade cascade>
                <StyledContentPanel style={{ marginBottom: '20px' }}>
                    <h1>{t('end_screen_text')}</h1>
                </StyledContentPanel>
                {!topicData?.topic.pvtShowCopyLink ? null :
                    navigator.share === undefined ?
                        <StyledButton disabled={copied} onClick={copyTopicLink}>
                            {copied ?
                                <>
                                    <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faCheck} /></span>
                                    {t('end_screen_copied_link')}
                                </>
                                : t('end_screen_copy_link')
                            }
                        </StyledButton> :
                        <StyledButton onClick={shareTopic}>
                            <span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faShare} /></span>
                            {t('end_screen_share_topic')}
                        </StyledButton>
                }
                {!topicData?.topic.pvtShowVoteAgain ? null : <StyledButton onClick={resetRating}>{t('end_screen_rating_again')}</StyledButton>}
                {!topics ? null : topics.map((topic, i) => 
                    <TopicCardComponent key={i} topic={topic} onClick={() => topicCardClicked(topic)} />
                )}
            </Fade>
        </animated.div>
    );
};

export default RatingEnd;